import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import DuplicateDetail from '../../components/duplicate/DuplicateDetail';

export class DuplicateModal extends React.Component {
  constructor(props) {
    super(props);

    this.duplicateDetail = undefined;

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };
  }

  onSaveHandler() {
    const { name } = this.duplicateDetail.getItemData();
    this.props.duplicate(this.props.item.id, name);
  }

  onHideHandler() {
    if (this.props.isDuplicating) return;
    const onHideFn = this.props.onHide;
    if (onHideFn) onHideFn();
  }

  render() {
    const {
      title,
      isDuplicating,
      errorMessage,
      label,
      onHide,
      duplicate,
      t,
      ...newProps
    } = this.props;
    const { isSubmittable } = this.state;

    return (
      <Modal
        {...newProps}
        onHide={this.onHideHandler.bind(this)}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title || t('copy')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DuplicateDetail
            label={label}
            ref={ref => (this.duplicateDetail = ref)}
            onValid={isValid => this.setState({ isValid })}
            onDirty={isDirty => this.setState({ isDirty })}
            onSubmittable={isSubmittable => this.setState({ isSubmittable })}
            fieldErrors={errorMessage}
            onSubmit={() => !this.props.isDuplicating && !this.props.isDuplicated && this.onSaveHandler()}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={!isSubmittable || isDuplicating}
            onClick={() => this.onSaveHandler()}
          >
            {isDuplicating ? `${t('copying')}...` : t('copy')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default translate('translations')(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/DuplicateModal.js